import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react'
import globalTheme from './theme';
import axios from 'axios';
import { getAuthToken } from './services/auth.service';
import TemplateCodeContextProvider from './pages/contextProvider/templateCodeProvider';

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  if(config.headers){
    config.headers.Authorization =  `Bearer ${getAuthToken()}`;
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ChakraProvider theme={globalTheme} >
      <TemplateCodeContextProvider>
        <App />
      </TemplateCodeContextProvider>
    </ChakraProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
